import { useState, useEffect } from 'react';

const HERO_IMAGES = [
  '/img/home.jpg',
  '/img/og-itaqueri.jpg',
  '/img/rapel.jpg',
];

interface HeroSectionProps {
  onExplore: () => void;
  onJumpCities: () => void;
  onJumpTrending: () => void;
  onJumpPremium: () => void;
  onJumpCouple: () => void;
}

export function HeroSection({
  onExplore,
  onJumpCities,
  onJumpTrending,
  onJumpPremium,
  onJumpCouple,
}: HeroSectionProps) {
  const [slide, setSlide] = useState(0);

  useEffect(() => {
    if (HERO_IMAGES.length <= 1) return;
    const id = setInterval(() => setSlide((s) => (s + 1) % HERO_IMAGES.length), 5000);
    return () => clearInterval(id);
  }, []);

  return (
    <section className="hero" aria-label="Itaqueri">
      <div className="hero__slides" aria-hidden="true">
        {HERO_IMAGES.map((src, i) => (
          <div
            key={i}
            className={`hero__bg${i === slide ? ' hero__bg--active' : ''}`}
            style={{ backgroundImage: `url(${src})` }}
          />
        ))}
        <div className="hero__overlay" />
      </div>

      <div className="hero__inner">
        <div className="hero__content">
          <span className="hero__eyebrow">Serra do Itaqueri</span>
          <h1 className="hero__title">
            Trilhas, cachoeiras e <span className="title-serif">experiências</span> locais, direto com quem opera.
          </h1>
          <p className="hero__subtitle">
            Reserve com confirmação imediata ou solicite com curadoria. Você escolhe.
          </p>

          <div className="hero__cta-row">
            <button type="button" className="btn btn--primary btn--lg" onClick={onExplore}>
              Explorar Experiências
            </button>
            <button type="button" className="btn btn--ghost" onClick={onJumpCities}>
              Ver cidades
            </button>
          </div>

          <nav className="hero__quick-nav" aria-label="Navegação rápida">
            <button type="button" onClick={onJumpTrending}>Em Alta</button>
            <button type="button" onClick={onJumpPremium}>Premium</button>
            <button type="button" onClick={onJumpCouple}>A Dois</button>
          </nav>
        </div>

        <div className="hero__dots" aria-hidden="true">
          {HERO_IMAGES.map((_, i) => (
            <button
              key={i}
              type="button"
              className={`hero__dot${i === slide ? ' hero__dot--active' : ''}`}
              onClick={() => setSlide(i)}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
